import { useGetCSRDProgressByYear } from "../../../hooks/query/csrd";
import { CSRD_QUESTIONNAIRE_TYPES, generateArrayOfYears, showErrorToast } from "../../../utils";
import { Box, FormLabel, Select, useToast } from "@chakra-ui/react";
import { Page } from "../../../components/Page";
import { Card } from "../../../components/Card";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import moment from "moment";
import { WithAuthorization } from "../../../context";
import { CSRDProgressChart } from "./components";

function CSRDViewProgress() {
  const { t } = useTranslation("translation", {
    keyPrefix: "csrd.viewProgress"
  });
  const toast = useToast();

  const [selectedYear, setSelectedYear] = useState((moment().year() - 1).toString());
  const [chartData, setChartData] = useState([]);

  useGetCSRDProgressByYear({ year: selectedYear }, {
    onSuccess: (data) => {
      const newChartData = [];

      if (data && Object.keys(data).length > 0) {
        Object.keys(data).forEach(categoryKey => {
          if (data[categoryKey] && Object.keys(data[categoryKey]).length > 0) {
            Object.keys(data[categoryKey]).forEach(topicKey => {
              const topicData = data[categoryKey][topicKey];
              newChartData.push({
                category: categoryKey,
                topic: topicData.topic,
                [t("completed")]: topicData.allCompleted ? topicData.count ?? 0 : topicData.completed ?? 0,
                [t("inProgress")]: topicData.inProgress ?? 0,
                [t("empty")]: topicData.empty ?? 0,
                [t("notApplicable")]: topicData.allNotApplicable ? topicData.count ?? 0 : topicData.notApplicable ?? 0
              });
            });
          }
        });
      }

      const ordering = {
        [CSRD_QUESTIONNAIRE_TYPES.ENVIRONMENTAL]: 1,
        [CSRD_QUESTIONNAIRE_TYPES.SOCIAL]: 2,
        [CSRD_QUESTIONNAIRE_TYPES.GOVERNANCE]: 3
      };
      newChartData.sort(function(a, b) {
        return (ordering[b.category] - ordering[a.category]) || b.topic.localeCompare(a.topic);
      });

      setChartData(newChartData);
    },
    onError: err => showErrorToast(toast, err.response?.data?.parameters?.message ?? err.message),
    cacheTime: 0
  });

  return (
    <Page>
      <Card>
        <Box marginBottom={4}>
          <FormLabel
            htmlFor={"filterByYear"}
            opacity="0.75"
            fontSize="xs"
            whiteSpace="nowrap"
            blockSize="5"
            isTruncated
            color="esg_gray.200"
            marginBottom={0}
          >
            {t("financialYear")}
          </FormLabel>
          <Select
            id={"filterByYear"}
            backgroundColor="white"
            borderRadius="none"
            value={selectedYear}
            onChange={(e) => setSelectedYear(e.target.value)}
            maxInlineSize={{ base: "full", lg: "xs" }}
          >
            {generateArrayOfYears().map((year) => <option key={year} value={year}>{year}</option>)}
          </Select>
        </Box>
        <CSRDProgressChart data={chartData} />
      </Card>
    </Page>
  );
}

export default WithAuthorization(CSRDViewProgress);